export default "/static/empty/no-case.png"